
import { Component, Vue, Prop } from 'vue-property-decorator';
import { isElementInViewport, throttle, getElementByAttr } from '@common/utils'

@Component({
  name: 'RouterTab',
  components: {},
})
export default class RouterTab extends Vue {
  @Prop({
    default: 'pc',
    required: false,
  })
  type!: string

  currentShow = 'video'

  switchRouter(type: string) {
    const videoDom = document.getElementById('bonus-pool') as HTMLDivElement
    const liveDom = getElementByAttr('section', 'data-fid', this.type === 'pc' ? 'MV2rbQqjWN0' : 'MoykZ3U9SG7') as HTMLDivElement
    if (type === 'video' && this.currentShow !== 'video') {
      videoDom.style.display = 'flex'
      liveDom.style.display = 'none'
      this.currentShow = 'video'
    } else if (type === 'live' && this.currentShow !== 'live') {
      liveDom.style.display = 'block'
      videoDom.style.display = 'none'
      this.currentShow = 'live'
    }
    // this.$router.push({ path: `/${type}` });
  }

  async mounted() {
    const liveDom = getElementByAttr('section', 'data-fid', this.type === 'pc' ? 'MV2rbQqjWN0' : 'MoykZ3U9SG7') as HTMLDivElement
    liveDom.style.display = 'none'
    // this.anime.lastFrame
    // this.anime.reverse().playTimes(1)
  }
}
